import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        borderRadius: 12,
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
        backgroundColor: "#fff",
        textAlign: "center",
        padding: "69px 120px 74px",
        outline: 'none',
        zIndex: 1800,
        [theme.breakpoints.down('md')]: {
    padding: "69px 64px 74px",
},
    },
    panel: {
    "& p": {
        marginTop: 20,
        fontSize: 16,
        [theme.breakpoints.down('md')]: {
            fontSize: 12,
            width: "auto",
        },
    },
},
    modalHeader: {
    marginBottom: 20,
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
        width: "auto",
    },
},
    boldText: {
    fontWeight: "bolder"
},
    timeProgress: {
    margin: "0 auto",
    width: 220,
    height: 196
},
    buttonSection: {
    marginTop: 77
},
    logoutButton: {
    width: 190,
    marginRight: 20,
    color: "#2D91E9",
    border: "1px solid #E8E8E8",
    background: "#FFF",
    zIndex: 1,
    "&:hover": {
        background: "#FFF",
        border: "1px solid #2D91E9",
    },
    [theme.breakpoints.down('md')]: {
        marginRight: 0,
    },
},
    continueButton: {
    width: 190,
    zIndex: 1
}
});